// @ts-ignore
import * as React from "react";
import { Button, ButtonUse, ButtonSize } from "react-ui";

import {
    CHECK_ACTION_BUTTON_CLICK,
    CLOSE_ACTION_BUTTON_CLICK,
    SAVE_CLOSE_ACTION_BUTTON_CLICK,
} from "../../metricsAction";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { ActionPanelButtonWidth } from "../Panel/PanelTypes";

import { ButtonCloseWorkAround } from "./ActionButton.styles";

type ActionButtonType = "close" | "check" | "save";

export interface ActionButtonProps {
    disabled?: boolean;
    place?: string;
    type: ActionButtonType;
    use?: ButtonUse;
    size?: ButtonSize;
    width?: number;
    onCheckErrors?: () => void;
    onCloseForm?: () => void;
    onSaveAndCloseForm?: () => void;
}

export function ActionButton(props: ActionButtonProps): JSX.Element {
    const track = useMetrics();

    const handleToClose = async (): Promise<void> => {
        track(CLOSE_ACTION_BUTTON_CLICK, { place: props.place });
        props.onCloseForm?.();
    };

    const handleToSaveClose = async (): Promise<void> => {
        track(SAVE_CLOSE_ACTION_BUTTON_CLICK, { place: props.place });
        props.onSaveAndCloseForm?.();
    };

    const handleToCheck = (): void => {
        track(CHECK_ACTION_BUTTON_CLICK, { place: props.place });
        props.onCheckErrors?.();
    };

    const buttons = {
        close: { text: "Закрыть", onClick: handleToClose },
        check: { text: "Проверить", onClick: handleToCheck },
        save: { text: "Сохранить и закрыть", onClick: handleToSaveClose },
    };

    const { text, onClick } = buttons[props.type];
    const { disabled, width, use, size = "medium" } = props;
    return (
        <Button
            data-focus="noFocus"
            disabled={disabled ?? false}
            size={size}
            width={width}
            use={use ?? "primary"}
            onClick={onClick}>
            {text === "Закрыть" && width === ActionPanelButtonWidth.smallSize ? (
                <ButtonCloseWorkAround>{text}</ButtonCloseWorkAround>
            ) : (
                text
            )}
        </Button>
    );
}
